import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Skeleton } from '@/components/ui/skeleton'
import { useOrganizationStore } from '@/store/organization'

export const OrganizationDropdown = () => {
  const organizations = useOrganizationStore((s) => s.organizations)
  const isLoading = useOrganizationStore((s) => s.isLoading)
  const organization = useOrganizationStore((s) => s.organization)
  const setOrganization = useOrganizationStore((s) => s.setOrganization)
  const isSwitchingOrganization = useOrganizationStore((s) => s.isSwitching)

  const handleChange = (value: string) => {
    const organization = organizations.find((org) => org.id === value)
    if (!organization) return
    void setOrganization(organization)
  }

  if (isLoading || !organization) {
    return <Skeleton className="h-10 min-w-[100px] max-w-[200px]" />
  }

  return (
    <Select
      value={organization.id}
      onValueChange={handleChange}
      disabled={isSwitchingOrganization}
    >
      <SelectTrigger className="min-w-[100px] max-w-[200px]">
        <SelectValue placeholder="Select" />
      </SelectTrigger>
      <SelectContent>
        {organizations?.map((org) => (
          <SelectItem key={org.id} value={org.id}>
            {org.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
